import Request from "@/common/net/request.js";
const request = new Request();
// 获取列表
export function getPage() {
  return request.send({
    url: `/pmy/sys/dict-type/list`,
    method: "get"
  });
}
// 添加
export function addInfo(data) {
  return request.send({
    url: `/pmy/sys/dict-type`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}

// 编辑
export function editInfo(data) {
  return request.send({
    url: `/pmy/sys/dict-type`,
    method: "put",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}

// 删除
export function deleteInfo(id) {
  return request.send({
    url: `/pmy/sys/dict-type?dictTypeId=${id}`,
    method: "delete"
  });
}

// 获取字典列表
export function getDictPage(id) {
  return request.send({
    url: `/pmy/sys/dict-data/list?dictType=${id}`,
    method: "get"
  });
}
// 添加字典
export function addDictInfo(data) {
  return request.send({
    url: `/pmy/sys/dict-data`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}

// 编辑字典
export function editDictInfo(data) {
  return request.send({
    url: `/pmy/sys/dict-data`,
    method: "put",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}

// 删除字典
export function deleteDictInfo(id) {
  return request.send({
    url: `/pmy/sys/dict-data?dictDataId=${id}`,
    method: "delete"
  });
}
